import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import availability from './availability/availability.js'
import add from './add.js'
import del from './del.js'
import init from './init.js'
import opener from './opener.js'

export default contract({
  add: array([
    add
  ]),
  availability,
  del: array([
    del
  ]),
  init: array([
    init
  ]),
  opener: array([
    opener
  ]),
})
